<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
    components: {},
    props: {
        title: {
            type: String,
            default: null,
        },
        titleId: {
            type: String,
            default: "No title",
        },
        breadCrumbTitles: {
            type: Array as PropType<string[]>,
            default: null,
        },
        gap: {
            type: Boolean,
            default: false,
        },
        disableAnimation: {
            type: Boolean,
            default: false,
        },
    },
    emits: [],
    data: () => ({}),
    computed: {},
    methods: {},
});
</script>

<template>
    <div :id="titleId" class="main-page flex flex--v flex--valign-c flex--gap-30" :class="{ 'main-page--gap': gap, 'disable-animation': disableAnimation }">
        <div class="main-page-title flex flex--valign-c flex--halign-c flex--gap-10">
            <span class="text text--size-14 text--accent-gray-a">&bull;</span>

            <span v-if="title" class="main-page-title-content main-page-title-content--current text text--size-18 text--semi-bold text--accent-gray-a text--uppercase">
                {{ title }}
            </span>

            <template v-else-if="breadCrumbTitles">
                <template v-for="(breadCrumbTitle, index) in breadCrumbTitles" :key="breadCrumbTitle">
                    <span v-if="index > 0" class="main-page-title-content text text--size-22 text--accent-gray-a text--bold">
                        {{ ">" }}
                    </span>
                    <span class="main-page-title-content text text--size-18 text--semi-bold text--accent-gray-a text--uppercase" :class="{ 'main-page-title-content--current': index + 1 >= breadCrumbTitles.length }">
                        {{ breadCrumbTitle }}
                    </span>
                </template>
            </template>

            <span v-else class="main-page-title-content main-page-title-content--current text text--size-18 text--semi-bold text--accent-gray-a text--uppercase">
                {{ "No title" }}
            </span>

            <span class="text text--size-14 text--accent-gray-a">&bull;</span>
        </div>

        <div class="main-page-content flex flex--v flex--valign-c flex--gap-60">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.main-page {
    width: 100%;
    max-width: 100%;
    animation: appearAnim 0.3s ease;
    margin-top: rem(5);

    &.disable-animation {
        animation: none;
    }

    &.main-page--gap {
        margin-top: rem(50);
    }

    .main-page-title {
        width: 100%;
        max-width: 100%;
    }

    .main-page-content {
        width: 100%;
        max-width: 100%;
    }
}

@include media-breakpoint-down(lg) {
    .main-page {
        gap: rem(25);

        &.main-page--gap {
            margin-top: rem(40);
        }

        .main-page-content {
            gap: rem(55);
        }
    }
}
@include media-breakpoint-down(md) {
    .main-page {
        gap: rem(20);

        &.main-page--gap {
            margin-top: rem(30);
        }

        .main-page-title {
            .main-page-title-content {
                &:not(.main-page-title-content--current) {
                    display: none;
                }
            }
        }

        .main-page-content {
            gap: rem(50);
        }
    }
}
@include media-breakpoint-down(sm) {
    .main-page {
        gap: rem(15);

        &.main-page--gap {
            margin-top: rem(20);
        }

        .main-page-content {
            gap: rem(45);
        }
    }
}
</style>
